import { render } from "./FinalFooter.vue?vue&type=template&id=b7b01bd0&scoped=true"
const script = {}

import "./FinalFooter.vue?vue&type=style&index=0&id=b7b01bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b01bd0"]])

export default __exports__